import React, {useRef, useState} from 'react';
import {useParams} from "react-router-dom";
import CompanyService from "../../../components/companies/services/CompanyService";
import CompanyActivityMasterScreen from "./CompanyActivityMasterScreen";
import ErrorsTable from "../../../components/activity/ui/ErrorsTable";
import Controller from "../../../components/common/services/Controller";

const CompanyErrorLogsScreen = (props) => {
    const {} = props;
    const { companyId } = useParams();
    const [company, setCompany] = useState(CompanyService.instance.companyMap[companyId] || null);
    const refreshController = useRef(new Controller()).current;

    const onCompany = (c) => {
        if (!!c) {
            setCompany(c);
        }
    };
    
    const refreshAsync = async () => {
        return await refreshController.refreshAsync();
    };
    
    const errorsTable = !!companyId && companyId.length > 0 ? (<ErrorsTable controller={refreshController} company={company} companyId={companyId} />) : null;
    
    return (
        <CompanyActivityMasterScreen onCompany={onCompany} title={"Company Errors"} selection={"errors"} onRefresh={refreshAsync}>
            <p>Errors occurred within the { company?.name } context.</p>
            { errorsTable }
        </CompanyActivityMasterScreen>
    );

};

export default CompanyErrorLogsScreen;
